import React from 'react';
import { LuCircleCheck, LuTriangleAlert, LuLoaderCircle } from 'react-icons/lu';
import XiLogo from './ui/XiLogo';

/**
 * Voice enrollment — page-level states.
 *
 * These replace the old inline light-only styles. They keep the same exported
 * names and props so `VoiceEnroll.jsx` / `VoiceEnrollStaff.jsx` need no change.
 */

function EnrollFrame({ children }) {
  return (
    <div className="xi-public xi-enroll">
      <div className="xi-public__veil" aria-hidden="true" />
      <div className="xi-public__body xi-enroll__state-body">
        <div className="xi-enroll__brand">
          <XiLogo size="sm" tagline />
        </div>
        {children}
      </div>
    </div>
  );
}

export function VoiceEnrollLoading() {
  return (
    <EnrollFrame>
      <div className="xi-auth-card xi-enroll__card xi-enroll__state" role="status" aria-live="polite">
        <span className="xi-enroll__state-icon" aria-hidden="true">
          <LuLoaderCircle className="xi-enroll__spin" />
        </span>
        <h2>Preparing your session</h2>
        <p className="xi-muted">Loading your enrollment details…</p>
        <div className="xi-stack" aria-hidden="true" style={{ width: '100%', marginTop: '1rem' }}>
          <div className="xi-skeleton" style={{ height: 12 }} />
          <div className="xi-skeleton" style={{ height: 12, width: '72%' }} />
        </div>
      </div>
    </EnrollFrame>
  );
}

export function VoiceEnrollError({ message }) {
  return (
    <EnrollFrame>
      <div className="xi-auth-card xi-enroll__card xi-enroll__state" role="alert">
        <span className="xi-enroll__state-icon is-bad" aria-hidden="true">
          <LuTriangleAlert />
        </span>
        <h2>We could not open this link</h2>
        <p className="xi-muted">{message}</p>
        <p className="xi-enroll__note">
          Ask the person who invited you for a fresh enrollment link.
        </p>
      </div>
    </EnrollFrame>
  );
}

export function VoiceEnrollSuccess({ name, message }) {
  return (
    <EnrollFrame>
      <div className="xi-auth-card xi-enroll__card xi-enroll__state" role="status">
        <span className="xi-enroll__state-icon is-ok" aria-hidden="true">
          <LuCircleCheck />
        </span>
        <h2>Voice recorded</h2>
        <p className="xi-muted">
          Thank you{name ? <strong> {name}</strong> : null}! Your voice recording has been saved
          successfully.
        </p>
        {message ? <p className="xi-enroll__note">{message}</p> : null}
      </div>
    </EnrollFrame>
  );
}

export function VoiceEnrollErrorBanner({ message }) {
  if (!message) return null;
  return (
    <div className="xi-alert xi-alert--bad" role="alert">
      <LuTriangleAlert aria-hidden="true" />
      <div className="xi-alert__body">
        <p className="xi-alert__text">{message}</p>
      </div>
    </div>
  );
}
